<div
  *ngIf="showBanner"
  class="maintenance-banner"
  [class.maintenance-banner--scheduled]="isScheduled"
  [class.maintenance-banner--winding-down]="isWindingDown"
>
  <div class="maintenance-banner__content">
    <span class="maintenance-banner__icon">
      <ng-container *ngIf="isWindingDown">⚠️</ng-container>
      <ng-container *ngIf="isScheduled">🔔</ng-container>
    </span>

    <span class="maintenance-banner__message">
      {{ state?.message || (isWindingDown ? 'Sistema entrará em manutenção em breve.' : 'Manutenção programada.') }}
    </span>

    <span class="maintenance-banner__countdown" *ngIf="countdown">
      {{ isWindingDown ? 'Indisponível em' : 'Início em' }}: <strong>{{ countdown }}</strong>
    </span>

    <a
      class="maintenance-banner__link"
      *ngIf="state?.releaseNotesUrl"
      [href]="state.releaseNotesUrl"
      target="_blank"
      rel="noopener"
    >
      Saiba mais
    </a>
  </div>
</div>
